import React from 'react';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from "react-router-dom";
import property1 from '../../../../images/property/1.jpg';
import DemoSlider from '../DemoSlider';
import CardFooter from '../CardFooter';
import BasicDetail from '../BasicDetail';

const PropertyGridView = ({ propertyRows, loading, handleDelete }) => {
  const navigate = useNavigate();

  const handleCardClick = (e, id) => {
    // Prevent redirect if dz-footer or its children are clicked
    if (
      e.target.closest('.dz-footer')
    ) {
      return;
    }
    navigate(`/property-details/${id}`);
  };

  return (
    <>
      <div className="row my-3">
        {loading ? (
          Array.from({ length: 6 }).map((_, idx) => (
            <div className="col-xl-3 col-xxl-4 col-md-6 col-sm-6 col-lg-4 m-b30" key={idx}>
              <Skeleton height={350} style={{ borderRadius: '16px' }} />
            </div>
          ))
        ) : (
          propertyRows.map((item, ind) => (
            <div className="col-xl-3 col-xxl-4 col-md-6 col-sm-6 col-lg-4 m-b30" key={ind}>                             
              <div 
                className="property-card style-1"
                onClick={(e) => handleCardClick(e, item._id)}
                style={{ cursor: "pointer" }}
              >
                {
                  item.imageUrls.length > 1 ?
                    <DemoSlider images={item.imageUrls} address={item.address} type={item?.listingTypeId?.name} isFeatured={item.isFeatured} isVerified={item.isVerified}/>
                  :
                  <div className="dz-media">
                    <ul>
                      <li className="badge badge-sm badge-primary light">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg> 
                        <span 
                          title={item.address}
                          className="address-tooltip"
                        >
                          {item.address}
                        </span>
                      </li>
                    </ul>
                    <ul className='property-badges-list'>
                      { item?.isFeatured && <li className="badge badge-sm badge-secondary">Featured</li>}
                      { item?.isVerified && <li className="badge badge-sm badge-success">Verified</li>}
                      <li className="badge badge-sm badge-primary">{item?.listingTypeId?.name}</li>
                    </ul>
                    <img 
                      src={item.imageUrls[0]} 
                      alt="/" 
                      onError={(e) => {
                        e.target.onerror = null; 
                        e.target.src = property1; 
                      }}
                    />
                  </div>
                }
                <div className="dz-content">
                  { item?.adStatus === 'blocked' && 
                    <div
                      style={{
                        background: '#ffeaea',
                        color: '#d32f2f',
                        border: '1px solid #f44336',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        marginBottom: '10px',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        flexDirection: 'column'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                        <svg width="18" height="18" fill="#d32f2f" viewBox="0 0 24 24">
                          <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-13h2v6h-2V7zm0 8h2v2h-2v-2z"/>
                        </svg>
                        <span style={{ fontWeight: 'bold', fontSize: '15px' }}>Blocked Property</span>
                      </div>
                      <div style={{ width: '100%', marginTop: '4px', fontWeight: 'normal', fontSize: '14px', color: '#b71c1c' }}>
                        Reason : {item?.adStatusNote}
                      </div>
                    </div>
                  }
                  { item?.adStatus === 'rejected' && 
                    <div
                      style={{
                        background: '#ffeaea',
                        color: '#d32f2f',
                        border: '1px solid #f44336',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        marginBottom: '10px',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        flexDirection: 'column'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                        <svg width="18" height="18" fill="#d32f2f" viewBox="0 0 24 24">
                          <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-13h2v6h-2V7zm0 8h2v2h-2v-2z"/>
                        </svg>
                        <span style={{ fontWeight: 'bold', fontSize: '15px' }}>Rejected Property</span>
                      </div>
                      <div style={{ width: '100%', marginTop: '4px', fontWeight: 'normal', fontSize: '14px', color: '#b71c1c' }}>
                        Reason : {item?.adStatusNote}
                      </div>
                    </div>
                  }
                  <h3 className="title">{item.title}</h3>
                  <h4 className="title">{item?.priceUnitId?.name ? item?.priceUnitId?.name : 'RS'}  {item.price}</h4>
                  <p>Posted on {moment(item.createdAt).format('MMM D, YYYY, h.mm A')}</p>
                  <div className="dz-meta">
                    <BasicDetail beds={item.numberOfBedrooms} bath={item.numberOfBathrooms} area={item.areaSize}/>      
                  </div>
                  <div style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}>
                    {item.description}
                  </div>
                  <hr />
                  <div className="dz-footer">
                    <div className="property-card">
                      <div className="property-media">
                        <img 
                          src={item.customerId?.profilePicture || property1}
                          alt="/" 
                          onError={(e) => {
                            e.target.onerror = null; 
                            e.target.src = property1; 
                          }}
                        />
                      </div>
                      <h6 className="title mb-0">{item.customerId?.name}</h6>
                    </div>
                    <CardFooter handleDelete={handleDelete} id={item._id}/>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default PropertyGridView;